import { useEffect } from "react";
import { useDeviceToken } from "./hooks/core/useFCMToken";
import { MantineProvider } from "@mantine/core";
import { DatesProvider } from "@mantine/dates";
import { RouterProvider } from "react-router-dom";
import { Notifications } from "@mantine/notifications";
import { router } from "./routes";
import { theme } from "./config/theme";
import { auth } from "./config/firebase";
import { GoogleMapsProvider } from "./shared/components/GoogleMapsProvider";
import { NavigationHistoryProvider } from "./shared/contexts/NavigationHistoryContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import "./styles/typography.css";

const App = () => {
  useDeviceToken();

  useEffect(() => {
    // Log auth state changes
    const unsubscribe = auth.onAuthStateChanged((user) => {
      console.log("Auth state changed:", {
        user: user
          ? {
              uid: user.uid,
              email: user.email,
              emailVerified: user.emailVerified,
            }
          : null,
      });
    });

    return () => unsubscribe();
  }, []);

  return (
    <MantineProvider theme={theme}>
      <DatesProvider>
        <GoogleMapsProvider>
          <NavigationHistoryProvider>
            <ThemeProvider>
              <Notifications position="top-right" />
              <RouterProvider router={router} />
            </ThemeProvider>
          </NavigationHistoryProvider>
        </GoogleMapsProvider>
      </DatesProvider>
    </MantineProvider>
  );
};

export default App;
